export const parsePhoneNumber = (number: string) => {
    let numberParsed = (number || '').replaceAll('-', '').replaceAll('.', '').replaceAll(' ', '')
    return numberParsed?.match(/.{1,3}/g)?.join(' ')
}